import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { isWatchingSelector, useGetWatchesQuery } from "@apac/price-watch";
import type { WatchAlertView } from "@b2bportal/air-price-watch-api";

export interface UnwatchTripRequest {
  tripId: string;
}

export enum WatchTripDialogView {
  WATCH = "watch",
  WATCH_SUCCESS = "watch_success",
  UNWATCH = "unwatch",
  "FAILURE" = "failure",
}

export interface UseWatchTripDialogReturn {
  context: {
    isWatching: boolean;
    currentView: WatchTripDialogView;
    watchList: WatchAlertView[];
  };
  handlers: {
    navigate: (view: WatchTripDialogView) => void;
    onClose: () => void;
  };
}

export const useWatchTripDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): UseWatchTripDialogReturn => {
  const { data: watchList } = useGetWatchesQuery();

  const isWatching: boolean = useSelector(isWatchingSelector);

  const [currentView, navigate] = useState<WatchTripDialogView>(
    isWatching ? WatchTripDialogView.UNWATCH : WatchTripDialogView.WATCH
  );

  const watches = useMemo(() => watchList?.watches ?? [], [watchList]);

  useEffect(() => {
    navigate(
      isWatching ? WatchTripDialogView.UNWATCH : WatchTripDialogView.WATCH
    );
  }, [open]);

  return {
    context: {
      isWatching,
      currentView,
      watchList: watches,
    },
    handlers: {
      navigate,
      onClose: () => {
        navigate(
          isWatching ? WatchTripDialogView.UNWATCH : WatchTripDialogView.WATCH
        );
        onClose?.();
      },
    },
  };
};
